<template>
  <behaviors-form
    :id="Number(behaviorId)"
    details
    @submit="addBehavior"
    @close="onClose"
  />
</template>
<script>
import BehaviorsForm from './BehaviorsForm.vue'

export default {
  name: 'EditBehavior',
  components: {
    BehaviorsForm,
  },
  data() {
    return {
      distributionId: null,
      behaviorId: null,
    }
  },
  created() {
    this.distributionId = this.$route.params.id
    this.behaviorId = this.$route.params.behaviorId
  },
  methods: {
    addBehavior(behavior) {
      this.$store.dispatch('cdn/updateBehavior', behavior).then(() => {
        this.successToast('Behavior was updated')
        this.onClose(this.distributionId)
      }).catch(error => this.errorToast(error.response?.data?.errors[0] || 'Something went wrong while updating behavior.'))
    },

    onClose(id) {
      this.$router.push({ name: 'distribution-behaviors', params: { id } })
    },
  },
}
</script>
